<template>
  <div>
    <t-dialog header="模型库" v-model:visible="modelShow" width="75%" :closeOnOverlayClick="false" top="50px" @confirm="confirmCheck">
      <t-form layout="inline" :model="searchForm">
        <t-button @click="showForm(false,null)">上传资源</t-button>
        <t-form-item label="资源名">
          <t-input v-model="searchForm.modelName" placeholder="请输入资源名"/>
        </t-form-item>
        <t-button @click="onSearch">查询</t-button>
        <t-loading size="small" :loading="loading"/>
      </t-form>
      <t-row  :gutter="6" style="padding-top: 10px;width: 100%;overflow: hidden">
        <t-col :span="2" v-for="item2 in modelData" :key="item2.id" @click.native="checkImg(item2)">
          <div style="height: 150px;" :style="{border: checkedItem.id === item2.id ? '1px solid #409eff':'1px solid transparent'}">
            <t-image style="width: 100%; height: 100%" :src="fileUrl+item2.modelPic" fit="fill"/>
          </div>
          <div style="height: 20px;margin-bottom: 6px;overflow: hidden">{{ item2.modelName }}</div>
        </t-col>
      </t-row>
      <t-pagination style="margin-top: 20px" size="small"
                    @page-size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current="pageConfig.pageNo" :page-size.sync="pageConfig.pageSize"
                    :total="pageConfig.total">
      </t-pagination>
    </t-dialog>
    <ThreeModelForm ref="designModelForm" @refreshTable="loadData"/>
  </div>
</template>

<script>
import {fileUrl} from "/env";
import {pageListApi} from "@/api/design-model";
import ThreeModelForm from "@/views/manage/design/form/three-model-form";

export default {
  name: "ThreeModels",
  components: {ThreeModelForm},
  data(){
    return {
      fileUrl,
      modelShow:false,
      modelData:[],
      checkedItem:{},
      pageConfig:{
        pageNo:1,
        pageSize:10,
        total:0
      },
      loading:false,
      searchForm:{modelName:""},
    }
  },
  methods:{
    onSearch() {
      this.pageConfig.pageNo = 1;
      this.pageConfig.pageSize = 10;
      this.loadData();
    },
    showForm(isEdit, row) {
      let rowData = {}
      if (isEdit) {
        rowData = JSON.parse(JSON.stringify(row))
      }
      this.$refs.designModelForm.opened(isEdit, rowData);
    },
    opened(){
      this.loadData();
    },
    loadData(){
      this.loading = true
      pageListApi(Object.assign(this.searchForm,this.pageConfig)).then(res => {
        this.modelData = res.data.records;
        this.pageConfig.total = res.data.total;
        this.modelShow = true;
        this.loading = false;
      })
    },
    confirmCheck(){
      if (!this.checkedItem || !this.checkedItem.id){
        this.$message.error('请选择模型')
      }else {
        this.$emit('confirmCheck', this.checkedItem.modelPath);
        this.modelShow = false
      }
    },
    checkImg(item){
      this.checkedItem = item
    },
    handleSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.loadData();
    },
  }
}
</script>

<style scoped>

</style>
